import { PickerOwnerState, PickersActionBarAction } from '@mui/x-date-pickers-pro';

export function desktopActionBar(actions: PickersActionBarAction[]) {
  return ({ pickerVariant }: Pick<PickerOwnerState, 'pickerVariant'>) =>
    pickerVariant === 'desktop' ? { actions } : {};
}
